const Awin = {
  affiliateId: 760287,
}

const MoneySuperMarket = {
  mid: 22713,
}

const Switchd = {
  mid: 15622,
}

const Plusnet = {
  mid: 2974,
}

const Axa = {
  mid: 12435,
}

// https://www.awin1.com/cread.php?awinmid=22713&awinaffid=760287&ued=https%3A%2F%2Fwww.moneysupermarket.com%2Fgas-and-electricity%2F
// https://www.awin1.com/cread.php?awinmid=2974&awinaffid=760287&clickref=&p=https://www.plus.net/business/deals/unlimited-business-fibre-broadband/?affiliate=awin&bannerId=fib-any-aff&utm_source=awin&utm_medium=biz-affiliate&utm_content=unlimited-business-fibre-broadband&utm_campaign=2122bizfib24mippaff
// https://www.awin1.com/cread.php?awinmid=12435&awinaffid=760287&ued=https%3A%2F%2Fwww.axa.co.uk%2Fget-axa-business-insurance%2F

export const Affiliates = {
  Awin: {
    HomeEnergy: {
      MoneySuperMarket: `https://www.awin1.com/cread.php?awinmid=${MoneySuperMarket.mid}&awinaffid=${Awin.affiliateId}&ued=https%3A%2F%2Fwww.moneysupermarket.com%2Fgas-and-electricity%2F`,
      Switchd: `https://www.awin1.com/cread.php?awinmid=${Switchd.mid}&awinaffid=${Awin.affiliateId}`,
    },
    BusinessBroadband: `https://www.awin1.com/cread.php?awinmid=${Plusnet.mid}&awinaffid=${Awin.affiliateId}&clickref=&p=https://www.plus.net/business/deals/unlimited-business-fibre-broadband/?affiliate=awin&bannerId=fib-any-aff&utm_source=awin&utm_medium=biz-affiliate&utm_content=unlimited-business-fibre-broadband&utm_campaign=2122bizfib24mippaff`,
    BusinessInsurance: `https://www.awin1.com/cread.php?awinmid=${Axa.mid}&awinaffid=${Awin.affiliateId}&ued=https%3A%2F%2Fwww.axa.co.uk%2Fget-axa-business-insurance%2F`,
  },
  Switchd: 'https://switchd.co.uk/?utm_source=switchpal&utm_channel=partnership',
  MakeMyHouseGreen: 'https://www.makemyhousegreen.com/?utm_source=switchpal',
  FundOnion:
    'https://www.fundonion.com/fundonion-switchpal?utm_source=switchpal&utm_medium=switchpal&utm_campaign=switchpal',
  SwitchPal: {
    Boadband: {
      Footer:
        'https://www.switchpal.com/quote/business-telecoms?utm_source=switchpal&utm_medium=web&utm_campaign=uk&utm_content=footer-link',
    },
    Payments: {
      Nav:
        'https://www.switchpal.com/business-finance/payments/barclaycard?utm_source=switchpal&utm_medium=web&utm_campaign=uk&utm_content=nav-link',
      Footer:
        'https://www.switchpal.com/business-finance/payments/barclaycard?utm_source=switchpal&utm_medium=web&utm_campaign=uk&utm_content=footer-link',
    },
  },
}
